export const compilationGroups = [
  "Pre-Recorded Live",
  "1-Minute",
  "Regular",
  "LiveStream Live",
  "Tests",
  "Reels",
];
